import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaPhoneAlt, FaYoutube } from 'react-icons/fa';
import { FiChevronDown } from 'react-icons/fi';
import { MdEmail } from 'react-icons/md';
import { SiGooglemaps } from 'react-icons/si';
import footerLogo from '../assests/img/footer-bridge-logo.png';

const API = 'https://admin.bridge365.in/wp-json/wc/v3';
const CK = "ck_1d0bfb52b9046a39fb2d906f89f691968931bce6";
const CS = "cs_956c51f2c9249f343bec7f0ecbfd7738654ba424";

const aboutLinks = [
  { label: 'About Us', to: '/about' },
  { label: 'Terms & Conditions', to: '/' },
  { label: 'Contact Us', to: '/contact' },
  { label: 'Privacy Policy', to: '/' },
];

function decodeHTML(html) {
  const txt = document.createElement('textarea');
  txt.innerHTML = html || '';
  return txt.value;
}

function Footer() {
  const [categories, setCategories] = useState([]);
  const [openSection, setOpenSection] = useState(null);

  useEffect(() => {
    fetch(`${API}/products/categories?per_page=50&consumer_key=${CK}&consumer_secret=${CS}`)
      .then(res => res.json())
      .then(data => {
        setCategories(Array.isArray(data) ? data.filter(cat => cat.parent === 0) : []);
      })
      .catch(() => setCategories([]));
  }, []);

  const toggleSection = (section) => {
    setOpenSection((current) => (current === section ? null : section));
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer-grid">
          <div className="site-footer-brand">
            <Link to="/" className="site-footer-logo">
              <img src={footerLogo} alt="Mobileacc " />
            </Link>
            <p>
              A platform for all your mobile accessories needs like mobile cases, mobile covers, mobile screen protectors, mobile chargers, mobile batteries, mobile headphones etc.
            </p>
            <div className="site-footer-social" aria-label="Social links">
              <a href="#" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href="#" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="#" aria-label="YouTube">
                <FaYoutube />
              </a>
            </div>
          </div>

          <div className={`site-footer-column${openSection === 'about' ? ' is-open' : ''}`}>
            <button
              type="button"
              className="site-footer-toggle"
              onClick={() => toggleSection('about')}
            >
              <h3>About</h3>
              <FiChevronDown />
            </button>
            <ul>
              {aboutLinks.map(link => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className={`site-footer-column${openSection === 'products' ? ' is-open' : ''}`}>
            <button
              type="button"
              className="site-footer-toggle"
              onClick={() => toggleSection('products')}
            >
              <h3>Our Products</h3>
              <FiChevronDown />
            </button>
            <ul className="site-footer-products">
              {categories.slice(0, 8).map(category => (
                <li key={category.id}>
                  <Link to={`/category/${category.id}`}>{decodeHTML(category.name)}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className={`site-footer-column site-footer-contact${openSection === 'contact' ? ' is-open' : ''}`}>
            <button
              type="button"
              className="site-footer-toggle"
              onClick={() => toggleSection('contact')}
            >
              <h3>Keep In Touch</h3>
              <FiChevronDown />
            </button>
            <ul>
              <li>
                <SiGooglemaps />
                <span>Bldg No. 2682 Basement, Street No. 2 Gurudwara Road New Delhi - 110005</span>
              </li>
              <li>
                <FaPhoneAlt />
                <a href="tel:+91 98102 96709">+91 98102 96709</a>
              </li>
              <li>
                <MdEmail />
                <a href="mailto:info@mobileacc.in">info@mobileacc.in</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="site-footer-copyright">
        <div className="container">
          <p>&copy; Copyright 2026 Bridge 365. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
